import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// Eliminar import de FacturasCliente y ReactDOM
// import { FacturasCliente } from './LiquidacionVales';
// import ReactDOM from 'react-dom';

// Definir constantes (MANTENER ESTAS)
const motivosDevolucion = {
  1: { texto: "Cambio de Precio", color: "#FF9800", icon: "💰" },
  3: { texto: "Dañado", color: "#F44336", icon: "⚠️" },
  4: { texto: "Devolución Cliente", color: "#9C27B0", icon: "👤" },
  5: { texto: "Exceso Inventario", color: "#3F51B5", icon: "📦" },
  6: { texto: "Fecha Vencimiento", color: "#2196F3", icon: "📅" },
  9: { texto: "Vencido", color: "#607D8B", icon: "⏰" },
  11: { texto: "Otro", color: "#795548", icon: "❓" }
};

const estadosDevolucion = {
  1: 'Creado',
  2: 'Autorizado',
  3: 'Asignado',
  4: 'Recolectado',
  5: 'No Recolectado',
  6: 'Recibido',
  7: 'Liquidado',
  8: 'SAP'
};

// Eliminar componente FacturaPortal (ya no se usa)

const ModalLiquidacion = ({ devolucion, onClose, onConfirmarLiquidacion }) => {
  const { user } = useSelector(state => state.auth);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [mostrarModalNumRef, setMostrarModalNumRef] = useState(false);
  const [numRefCliente, setNumRefCliente] = useState('');
  const [enviandoNumRef, setEnviandoNumRef] = useState(false);

  // Función para enviar el número de referencia del cliente
  const handleEnviarNumRef = async () => {
    if (!numRefCliente.trim()) {
      setError('Por favor, ingrese el número de referencia del cliente');
      return;
    }

    setEnviandoNumRef(true);
    setError(null);
    
    try {
      const datos = {
        ID_VALE: devolucion.ID_Vale,
        NumRefCliente: numRefCliente.trim()
      };
      
      console.log('📤 Enviando a API ActualizarNumRefCliente:', datos);
      
      const payload = {
        Token: user?.token || "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
        Ambiente: "DESA",
        Dispositivo: {
          Marca: "SAMSUNG",
          Modelo: "S22002B",
          Version: "Android 18.125",
          McAdress: null,
          PowerStatus: "84%",
          WifiStatus: "Conected to iphone de Mauricio",
          GPSStatus: "ON",
          GPS: "321|-485|321"
        },
        User: {
          Codigo: user?.Codigo || "",
          UserNickName: user?.UserNickName || "pierril"
        },
        Metodo: {
          NombreMetodo: "ActualizarNumRefCliente",
          Datos_Recibidos: JSON.stringify(datos),
          Datos_Generados: ""
        }
      };
      
      const response = await fetch('https://appcorp.parma.com.gt/apipp/ReceptorDatos?Datos=', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });
      
      const result = await response.json();
      console.log('Respuesta:', result);
      
      if (result.datos_Generados) {
        const resp = JSON.parse(result.datos_Generados);
        if (resp[0].MENSAJE == "Numero de Vale del cliente, Actualizado exitosamente") {
          setMostrarModalNumRef(false);
          setNumRefCliente('');
          alert('✅ Número de referencia actualizado correctamente');
        } else {
          throw new Error(resp.Mensaje || "Error al actualizar");
        }
      } else {
        throw new Error("Respuesta inválida de la API");
      }
      
    } catch (error) {
      console.error('Error al actualizar referencia:', error);
      setError(`Error: ${error.message}`);
    } finally {
      setEnviandoNumRef(false);
    }
  };

  // Función para confirmar la liquidación final (simplificada)
  const handleConfirmarLiquidacion = async () => {
    setCargando(true);
    setError(null);
    
    try {
      if (!devolucion.DEV_DET || devolucion.DEV_DET.length === 0) {
        throw new Error('No hay productos para liquidar');
      }

      console.log('✅ Validaciones pasadas, procediendo con liquidación final');
      
      const datosLiquidacionFinal = {
        ID_VALE: devolucion.ID_Vale
      };

      console.log('📤 Enviando a API CargarDevolucion_a_Solicitud:', datosLiquidacionFinal);
      
      await onConfirmarLiquidacion(datosLiquidacionFinal, 'final');
      onClose();

    } catch (error) {
      console.error('Error al confirmar liquidación:', error);
      setError(error.message);
    } finally {
      setCargando(false);
    }
  };

  if (!devolucion) return null;

  const totalUnidades = devolucion.DEV_DET.reduce((sum, p) => sum + p.Cantidad, 0);

  return (
    <>
      <div className="modal-overlay modal-liquidacion-overlay">
        <div className="modal-content-liquidacion modal-liquidacion-content">
          {/* Header */}
          <div className="modal-header modal-liquidacion-header">
            <div className="header-content">
              <div className="header-icon-title">
                <span className="header-icon">💰</span>
                <div>
                  <h2>Confirmar Liquidación de Vale</h2>
                  <p className="header-subtitle">Proceso final para cerrar la devolución</p>
                </div>
              </div>
              <div className="header-badges">
                <span className="badge-vale">
                  Vale: <strong>{devolucion.ID_Vale}</strong>
                </span>
                <button 
                  className="btn-numref-header"
                  onClick={() => setMostrarModalNumRef(true)}
                  style={{
                    background: '#f0f0f0',
                    border: '1px solid #ddd',
                    borderRadius: '6px',
                    padding: '4px 12px',
                    cursor: 'pointer',
                    fontSize: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    fontWeight: '500'
                  }}
                >
                  <span style={{ fontSize: '14px' }}>🔖</span> 
                  Ref. Cliente
                </button>
                <span className="badge-estado">
                  Estado: <strong>{estadosDevolucion[devolucion.Id_Rastreo] || 'Creado'}</strong>
                </span>
              </div>
            </div>
            <button className="btn-cerrar-modal" onClick={onClose}>×</button>
          </div>

          {error && (
            <div className="error-mensaje-modal" style={{
              backgroundColor: '#ffebee',
              color: '#c62828',
              padding: '12px 16px',
              borderRadius: '4px',
              margin: '16px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              border: '1px solid #ef9a9a'
            }}>
              <span style={{ fontSize: '20px' }}>❌</span>
              <span style={{ flex: 1 }}>{error}</span>
              <button 
                onClick={() => setError(null)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: '#c62828'
                }}
              >
                ×
              </button>
            </div>
          )}

          <div className="modal-body modal-liquidacion-body">
            {/* Información General */}
            <div className="seccion-info-general modal-info-section">
              <div className="section-title">
                <span className="title-icon">📋</span>
                <h3>Información del Vale</h3>
              </div>
              <div className="info-grid-modal modal-info-grid">
                <div className="info-card">
                  <div className="info-card-icon">🏷️</div>
                  <div className="info-card-content">
                    <div className="info-card-label">Vale</div>
                    <div className="info-card-value destacado">{devolucion.ID_Vale}</div>
                  </div>
                </div>
                <div className="info-card">
                  <div className="info-card-icon">👤</div>
                  <div className="info-card-content">
                    <div className="info-card-label">Cliente</div>
                    <div className="info-card-value">{devolucion.Cliente}</div>
                  </div>
                </div>
                <div className="info-card">
                  <div className="info-card-icon">📍</div>
                  <div className="info-card-content">
                    <div className="info-card-label">Ruta</div>
                    <div className="info-card-value">{devolucion.Ruta}</div>
                  </div>
                </div>
                <div className="info-card">
                  <div className="info-card-icon">📅</div>
                  <div className="info-card-content">
                    <div className="info-card-label">Fecha</div>
                    <div className="info-card-value">{new Date(devolucion.Fecha_Ruta).toLocaleDateString()}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Lista de Productos */}
            <div className="seccion-productos-liquidacion modal-productos-section">
              <div className="section-title">
                <span className="title-icon">📦</span>
                <h3>Productos para Liquidación</h3>
                <span className="title-badge">{devolucion.DEV_DET.length} productos • {totalUnidades} unidades</span>
              </div>

              <div className="productos-table-container">
                <div className="table-scroll-wrapper">
                  <table className="productos-table">
                    <thead>
                      <tr>
                        <th className="col-codigo">Código</th>
                        <th className="col-nombre">Producto</th>
                        <th className="col-cantidad">Cantidad</th>
                        <th className="col-lote">Lote</th>
                        <th className="col-motivo">Motivo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {devolucion.DEV_DET.map((producto) => {
                        const motivo = motivosDevolucion[producto.ID_Motivo_Devolucion];
                        
                        return (
                          <tr key={producto.ID_Devolucion_Detalle} className="producto-row">
                            <td className="col-codigo">
                              <span className="codigo-producto">
                                {producto.ID_Producto}
                              </span>
                            </td>
                            <td className="col-nombre">
                              <div className="nombre-producto" title={producto.ItemName}>
                                {producto.ItemName}
                              </div>
                            </td>
                            <td className="col-cantidad">
                              <span className="cantidad-badge">
                                {producto.Cantidad}
                              </span>
                            </td>
                            <td className="col-lote">
                              <span className="lote-texto">
                                {producto.Lote || "N/A"}
                              </span>
                            </td>
                            <td className="col-motivo">
                              <div 
                                className="badge-motivo-con-icono"
                                style={{
                                  backgroundColor: `${motivo?.color}15`,
                                  borderLeft: `4px solid ${motivo?.color}`
                                }}
                              >
                                <span className="motivo-icon">{motivo?.icon || "❓"}</span>
                                <span className="motivo-texto">
                                  {motivo?.texto || `Motivo ${producto.ID_Motivo_Devolucion}`}
                                </span>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Resumen de Totales */}
              <div className="resumen-totales">
                <div className="totales-grid">
                  <div className="total-card">
                    <div className="total-icon">📦</div>
                    <div className="total-content">
                      <div className="total-label">Total Productos</div>
                      <div className="total-value">{devolucion.DEV_DET.length} items</div>
                    </div>
                  </div>
                  <div className="total-card">
                    <div className="total-icon">📊</div>
                    <div className="total-content">
                      <div className="total-label">Total Unidades</div>
                      <div className="total-value">{totalUnidades} unidades</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Mensaje de Confirmación */}
            <div className="confirmacion-section">
              <div className="confirmacion-card">
                <div className="confirmacion-icon">⚠️</div>
                <div className="confirmacion-content">
                  <h4>Confirmación Requerida</h4>
                  <p className="confirmacion-texto">
                    Esta acción cambiará el estado del vale a <strong>"Liquidado"</strong> 
                    y enviará el vale a SAP. Esta operación no se podrá revertir.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="modal-footer modal-liquidacion-footer">
            <div className="footer-left">
              <span className="estado-preparacion">
                <span className="preparado">
                  <span className="estado-icon">✅</span>
                  Listo para liquidar
                </span>
              </span>
            </div>
            <div className="footer-right">
              <button 
                className="btn-cancelar" 
                onClick={onClose} 
                disabled={cargando}
              >
                <span className="btn-icon">✖️</span>
                Cancelar
              </button>
              <button
                className="btn-confirmar-liquidacion"
                onClick={handleConfirmarLiquidacion}
                disabled={cargando}
              >
                {cargando ? (
                  <>
                    <span className="btn-spinner"></span>
                    Procesando Liquidación...
                  </>
                ) : (
                  <>
                    <span className="btn-icon">💰</span>
                    Confirmar Liquidación
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal para Número de Referencia del Cliente */}
      {mostrarModalNumRef && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 100000
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            width: '450px',
            maxWidth: '90%',
            padding: '24px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '16px'
            }}>
              <h3 style={{ margin: 0, fontSize: '18px' }}>
                <span style={{ marginRight: '8px' }}>🔖</span>
                Referencia del Cliente
              </h3>
              <button
                onClick={() => setMostrarModalNumRef(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#999'
                }}
              >
                ×
              </button>
            </div>
            
            <p style={{ margin: '0 0 8px 0', fontSize: '14px', color: '#666' }}>
              Ingrese el número de vale proporcionado por el cliente
            </p>
            
            <div style={{
              backgroundColor: '#f5f5f5',
              padding: '12px',
              borderRadius: '8px',
              marginBottom: '20px'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                <span style={{ fontSize: '13px', color: '#666' }}>Vale:</span>
                <span style={{ fontSize: '14px', fontWeight: '600', color: '#2196f3' }}>
                  {devolucion.ID_Vale}
                </span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ fontSize: '13px', color: '#666' }}>Cliente:</span>
                <span style={{ fontSize: '14px', fontWeight: '500' }}>
                  {devolucion.Cliente}
                </span>
              </div>
            </div>
            
            <input
              type="text"
              value={numRefCliente}
              onChange={(e) => setNumRefCliente(e.target.value)}
              placeholder="Ejemplo: 3216574987"
              disabled={enviandoNumRef}
              autoFocus
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '14px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                marginBottom: '20px',
                boxSizing: 'border-box'
              }}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleEnviarNumRef();
                }
              }}
            />
            
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setMostrarModalNumRef(false)}
                disabled={enviandoNumRef}
                style={{
                  padding: '8px 20px',
                  background: '#f0f0f0',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: enviandoNumRef ? 'not-allowed' : 'pointer',
                  fontSize: '14px'
                }}
              >
                Cancelar
              </button>
              <button
                onClick={handleEnviarNumRef}
                disabled={enviandoNumRef}
                style={{
                  padding: '8px 24px',
                  background: '#2196f3',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: enviandoNumRef ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                {enviandoNumRef ? (
                  <>
                    <span className="spinner-pequeno"></span>
                    Enviando...
                  </>
                ) : (
                  <>
                    <span>✓</span>
                    Confirmar
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ModalLiquidacion;